if (!customElements.get('mountain-chalet-upsell-modal')) {
  customElements.define(
    'mountain-chalet-upsell-modal',
    class MountainChaletUpsellModal extends HTMLElement {
      constructor() {
        super();
        this.variantId = this.dataset.variantId;
        this.addButton = this.querySelector('[data-mcu-add]');
        this.closeButtons = this.querySelectorAll('[data-mcu-close]');

        this.closeButtons.forEach((btn) => btn.addEventListener('click', () => this.resolveWith(null)));
        this.addButton.addEventListener('click', () => this.handleAddClick());
        this.addEventListener('keydown', (e) => {
          if (e.key === 'Escape') this.resolveWith(null);
        });

        // Safety: if something goes wrong, never trap the shopper here.
        this.failSafeTimer = null;
      }

      /**
       * Shows the modal for the item that was just added.
       * Resolves with the cart response from /cart/add.js if the shopper
       * adds the Mountain Chalet box, or null if they decline/close.
       * Caller is responsible for rendering the cart drawer afterward.
       */
      show(addedVariantId) {
        return new Promise((resolve) => {
          // Never show the popup if the item just added IS the Mountain Chalet box itself.
          if (String(addedVariantId) === String(this.variantId)) {
            resolve(null);
            return;
          }

          this._resolve = resolve;
          this.hidden = false;
          document.body.classList.add('mcu-modal-open');
          this.lastFocused = document.activeElement;
          this.addButton.focus();

          // Safety net: auto-dismiss after 20s of no interaction so a shopper
          // is never stuck unable to see their cart.
          this.failSafeTimer = setTimeout(() => this.resolveWith(null), 20000);
        });
      }

      resolveWith(value) {
        if (this.failSafeTimer) clearTimeout(this.failSafeTimer);
        this.hidden = true;
        document.body.classList.remove('mcu-modal-open');
        if (this.lastFocused && this.lastFocused.focus) this.lastFocused.focus();
        if (this._resolve) {
          this._resolve(value);
          this._resolve = null;
        }
      }

      handleAddClick() {
        this.addButton.setAttribute('aria-disabled', 'true');
        this.addButton.querySelector('.mcu-modal__spinner').classList.remove('hidden');

        const body = JSON.stringify({
          id: this.variantId,
          quantity: 1,
        });

        fetch(`${window.routes ? window.routes.cart_add_url : '/cart/add.js'}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body,
        })
          .then((response) => response.json())
          .then((response) => {
            this.resolveWith(response);
          })
          .catch((e) => {
            console.error('Mountain Chalet upsell add failed:', e);
            this.resolveWith(null);
          })
          .finally(() => {
            this.addButton.removeAttribute('aria-disabled');
            this.addButton.querySelector('.mcu-modal__spinner').classList.add('hidden');
          });
      }
    }
  );
}